import React, { useState } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Box,
  InputAdornment,
  TextField,
  Collapse,
  Select,
  FormControl,
  CircularProgress,
} from "@mui/material";
import { AccountCircle, ExpandMore, Search } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CCBAppBarLogo from "../../assets/Nav Bar.png";
import "../../components/connect/connect.css";
import "./AwsAccountsList.css";

const AwsAccountsPage = () => {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const [showProfileDetails, setShowProfileDetails] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [accessLoading, setAccessLoading] = useState(null); // stores account.id while loading

  const username = localStorage.getItem("username") || "User";
  const accountNo = localStorage.getItem("accountNo") || "123456789012";

  const handleProfileClick = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => { setAnchorEl(null); setShowProfileDetails(false); };
  const handleLogOut = () => { localStorage.clear(); navigate("/"); };

  const { accounts, regions } = (() => {
    const DEFAULT_REGIONS = ["us-east-1", "us-west-2", "ap-south-1", "eu-west-1"];
    let realAccounts = [];
    let apiRegions = DEFAULT_REGIONS;

    try {
      const raw = localStorage.getItem("LoginResponse");
      if (!raw) throw new Error("No LoginResponse");

      const responseData = JSON.parse(raw);
      let body = responseData.body;
      if (typeof body === "string") {
        try { body = JSON.parse(body); } catch (e) {}
      }
      if (!body) body = responseData;

      apiRegions =
        (Array.isArray(body.regions) && body.regions.length > 0 ? body.regions : null) ||
        DEFAULT_REGIONS;

      if (Array.isArray(body) && body.length > 0) {
        realAccounts = body.map((acc, i) => ({
          id: i + 1,
          name: acc.awsAccountName || acc.AccountName || acc.accountName || acc.Name || acc.name || `Account ${i + 1}`,
          accountId: acc.AwsAccountId || acc.awsAccount || acc.CustomerAWSAccountId || acc.AccountId || acc.accountId || "",
          regions: Array.isArray(acc.regions) && acc.regions.length > 0 ? acc.regions : apiRegions,
        }));
      } else {
        const list = body.accounts || body.Accounts || body.awsAccounts || body.AwsAccounts || body.accountList || body.AccountList;
        if (Array.isArray(list) && list.length > 0) {
          realAccounts = list.map((acc, i) => ({
            id: i + 1,
            name: acc.awsAccountName || acc.AccountName || acc.accountName || acc.Name || acc.name || `Account ${i + 1}`,
            accountId: acc.AwsAccountId || acc.awsAccount || acc.CustomerAWSAccountId || acc.AccountId || acc.accountId || "",
            regions: Array.isArray(acc.regions) && acc.regions.length > 0 ? acc.regions : apiRegions,
          }));
        } else {
          const singleId = body.AwsAccountId || body.awsAccount || body.CustomerAWSAccountId || body.AccountId || body.accountId;
          if (singleId) {
            realAccounts = [{
              id: 1,
              name: body.awsAccountName || body.AccountName || body.accountName || body.companyName || "My Account",
              accountId: singleId,
              regions: apiRegions,
            }];
          }
        }
      }
    } catch (err) {
      console.warn("AwsAccountsPage fallback:", err.message);
      const accountId = localStorage.getItem("CustomerAWSAccountId");
      const email = localStorage.getItem("Email");
      if (accountId) {
        realAccounts = [{ id: 1, name: email || "My Account", accountId, regions: DEFAULT_REGIONS }];
      }
    }

    const dummyAccounts = [
      { id: "dummy-1", name: "Multi Tenant 2", accountId: "987654321012", isDisabled: true },
      { id: "dummy-2", name: "Multi Tenant 4", accountId: "555666777888", isDisabled: true },
      { id: "dummy-3", name: "Multi Tenant 7", accountId: "111222333444", isDisabled: true },
    ];

    return {
      accounts: [...realAccounts, ...dummyAccounts],
      regions: apiRegions,
    };
  })();

  const filteredAccounts = accounts.filter(
    (a) =>
      (a.name || "").toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
      (a.accountId || "").toString().toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleAccessInstance = async (account) => {
    if (account.isDisabled) return;
    setAccessLoading(account.id);

    try {
      const response = await axios.post(
        "https://grj87qmm19.execute-api.us-east-1.amazonaws.com/Test/ListInstances",
        {
          awsAccount: account.accountId,
        }
      );

      let body = response.data?.body;
      if (typeof body === "string") {
        try { body = JSON.parse(body); } catch (_) {}
      }
      if (!body) body = response.data; // use the response data directly if no body exists (new API format)

      const instancesList = body?.instances ?? [];
      const firstRegion = instancesList.length > 0 ? instancesList[0].Region : "";

      // Store ONLY the full ListInstances response
      localStorage.setItem(
        "ListInstancesResponse",
        JSON.stringify({
          awsAccount: account.accountId,
          region: firstRegion,
          instanceCount: instancesList.length,
          instances: instancesList,
        })
      );

      // Also store CustomerAWSAccountId and Region for the legacy application logic
      localStorage.setItem("CustomerAWSAccountId", account.accountId);
      localStorage.setItem("Region", firstRegion || "");

      navigate("/instanceList-page");

    } catch (err) {
      console.error("ListInstances failed:", err);
      // Store minimal fallback
      localStorage.setItem(
        "ListInstancesResponse",
        JSON.stringify({ awsAccount: account.accountId, instanceCount: 0, instances: [] })
      );
      navigate("/instanceList-page");
    } finally {
      setAccessLoading(null);
    }
  };



  return (
    <>
      {/* ===== NAVBAR ===== */}
      <AppBar
        position="static"
        elevation={0}
        sx={{ backgroundColor: "#fff", boxShadow: "0 2px 6px rgba(0,0,0,0.08)" }}
      >
        <Toolbar className="appbar-connectadmin-container">
          <img src={CCBAppBarLogo} alt="Logo" className="connect-navbar-logo" />
          <img src={CCBAppBarLogo} alt="Logo" className="small-screen-logo" />
          <div className="connect-profile-section">
            <AccountCircle className="user-logo-connect" onClick={handleProfileClick} style={{ cursor: "pointer" }} />
            <Typography variant="h6" className="connectnavbarstyle" onClick={handleProfileClick} style={{ cursor: "pointer" }}>
              {username}
            </Typography>
            <IconButton onClick={handleProfileClick} color="inherit">
              <ExpandMore className="connectnavexpandbtn" />
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
              {showProfileDetails ? (
                <div style={{ padding: "10px", minWidth: "200px" }}>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <span style={{ fontWeight: "bold" }}>Username:</span><span>{username}</span>
                  </div>
                  <div style={{ display: "flex", gap: "8px", marginTop: "5px" }}>
                    <span style={{ fontWeight: "bold" }}>Account ID:</span><span>{accountNo}</span>
                  </div>
                  <Button onClick={() => setShowProfileDetails(false)} sx={{ mt: 1 }}>Back</Button>
                </div>
              ) : (
                <>
                  <MenuItem onClick={() => setShowProfileDetails(true)}>My Profile</MenuItem>
                  <MenuItem onClick={handleLogOut}>Logout</MenuItem>
                </>
              )}
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      {/* ===== PAGE CONTENT — directly on background ===== */}
      <div className="aws-page-wrapper">

        {/* Header: title (left) + search (right) */}
        <div className="aws-header-row">
          <h2 className="aws-title">
            AWS Accounts{" "}
            <span className="aws-title-count">({filteredAccounts.length})</span>
          </h2>

          <TextField
            placeholder="Filter accounts by name or ID"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            size="small"
            sx={{ maxWidth: 360, width: "100%" }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search sx={{ fontSize: 17, color: "#687078" }} />
                </InputAdornment>
              ),
              sx: {
                backgroundColor: "#fff",
                borderRadius: "4px",
                fontSize: "14px",
                height: "36px",
                "& fieldset": { borderColor: "#d1d5db" },
                "&:hover fieldset": { borderColor: "#687078" },
                "&.Mui-focused fieldset": { borderColor: "#0073bb", borderWidth: "2px" },
              },
            }}
          />
        </div>

        {/* Account list — tile grid layout */}
        {filteredAccounts.length > 0 ? (
          <div className="aws-accounts-grid">
            {filteredAccounts.map((account) => (
              <div
                key={account.id}
                className={`aws-account-tile ${account.isDisabled ? "aws-account-tile--disabled" : ""}`}
                onClick={() => handleAccessInstance(account)}
              >
                {/* {account.isDisabled && (
                  <div className="aws-tile-badge">Sandbox</div>
                )} */}
                <div className="aws-tile-content">
                  <div className="aws-tile-text">
                    <span className="aws-tile-name">{account.name}</span>
                    <span className="aws-tile-id">{account.accountId}</span>
                  </div>
                  <div className="aws-tile-icon">
                    {accessLoading === account.id ? (
                      <CircularProgress size={24} sx={{ color: "#6366f1" }} />
                    ) : (
                      <svg className="aws-account-icon" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                        <polygon points="32,4 4,18 4,46 32,60 60,46 60,18" fill="#F7A80D"/>
                        <polygon points="32,4 4,18 32,32 60,18" fill="#F9B928"/>
                        <polygon points="32,32 32,60 60,46 60,18" fill="#E8951D"/>
                        <line x1="32" y1="32" x2="32" y2="60" stroke="#2D2D2D" strokeWidth="1" opacity="0.2"/>
                        <line x1="32" y1="32" x2="60" y2="18" stroke="#2D2D2D" strokeWidth="1" opacity="0.15"/>
                        <line x1="32" y1="32" x2="4" y2="18" stroke="#2D2D2D" strokeWidth="1" opacity="0.15"/>
                      </svg>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="aws-empty-state">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{margin: "0 auto 12px"}}>
              <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="#c7c7cc"/>
            </svg>
            No accounts match your search
          </div>
        )}
      </div>
    </>
  );
};

export default AwsAccountsPage;